import { createSelector, createFeatureSelector } from '@ngrx/store';

export const selectAlertMessages = createFeatureSelector<OLO.State.AlertMessages.AlertMessage[]>('alertMessages');

export const getAlertMessages = createSelector(selectAlertMessages, (alertMessages: OLO.State.AlertMessages.AlertMessage[]) => alertMessages);
